import React from 'react';
import { Table } from 'reactstrap';
const fm = new Intl.NumberFormat("es-MX", {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
  });
const Columns = ({filters}) => {
		let columns = [
			{
				id: 'table',
				name: '',
        minWidth: '800px',
				cell: e => (
					<Table className="">
                      <thead>
                        <tr>
                          <th width={"10%"}>Unidad</th>
                          <th width={"30%"}>Periodo</th>
                          <th width={"30%"}>Ramal</th>
                          <th width={"15%"}>Vueltas</th>
                          <th width={"15%"}>Ingreso</th>
                        </tr>
                      </thead>
                      <tbody>
                        {e.salidas_count == 0 && (
                          <tr>
                            <td>{e.number}</td>
                            <td>{filters.initDate} al {filters.endDate}</td>
                            <td></td>
                            <td>0</td>
                            <td className="text-end">{fm.format(0)}</td>
                          </tr>
                        )}
                        {Object.keys(e.salidas_by_ramal).map((s, si) => (
                          <tr key={si}>
                            <td>{si == 0 ? e.number : ""}</td>
                            <td>{si == 0 ? filters.initDate + ' al ' + filters.endDate:''}</td>
                            <td>{e.salidas_by_ramal[s][0].ramal_nombre}</td>
                            <td>{e.salidas_by_ramal[s].length}</td>
                            <td className="text-end">
                              {fm.format(
                                e.salidas_by_ramal[s].reduce((temp, item) => {
                                  return temp + Number(item.cost);
                                }, 0)
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th colSpan={4} className="text-end">
                            Total
                          </th>
                          <th className="text-end">
                            {fm.format(e.salidas_ingreso)}
                          </th>
                        </tr>
                      </tfoot>
                    </Table>
				)
			},
			
		];
	return columns;
}

export default Columns;

//vaneton beicli